<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kategori Ekleme">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Eklenecek kategori adı ve arama motoru
                bağlantı linki benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" to="/categories">
            Kategori Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Kategori Ekleme Formu">
            <b-form>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Kategori Adı" label-for="name">
                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Kategori Adı">
                      <b-form-input id="name" v-model="name" placeholder="Kategori Adı"
                        :state="errors.length > 0 ? false : null"
                        :class="name.length >= chars.name ? 'text-danger' : ''" />
                      <small class="textarea-counter-value float-right"
                        :class="name.length >= chars.name ? 'bg-danger' : ''">
                        <span class="char-count">{{ name.length }}</span>
                        /
                        {{ chars.name }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Bağlantı Başlığı">
                      <b-form-input id="linkTitle" v-model="linkTitle" placeholder="Bağlantı Başlığı"
                        :state="errors.length > 0 ? false : null" :class="
                          linkTitle.length >= chars.linkTitle
                            ? 'text-danger'
                            : ''
                        " />
                      <small class="textarea-counter-value float-right" :class="
                        linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''
                      ">
                        <span class="char-count">{{ linkTitle.length }}</span>
                        /
                        {{ chars.linkTitle }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-form-group label="Üst Kategori" label-for="category">
                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Üst Kategori">
                      <v-select id="category" v-model="selectedCategory"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name" :options="categories" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Kategori Dili" label-for="lang">
                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Kategori Dili">
                      <v-select id="lang" v-model="selectedLanguage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name" disabled :options="languages" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Kategori Tipi" label-for="type">
                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Kategori Tipi">
                      <v-select id="type" v-model="selectedCategoryType" label="name"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="categoryTypes" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="İçerik" label-for="text">
                    <EditorById v-if="isLoaded" id="text" ref="refEditor"></EditorById>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Kategori Bilgisi" label-for="information">
                    <EditorById v-if="isLoaded" id="information" ref="refEditorInformation"></EditorById>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="8">
                  <DragDropImage ref="refCardImage" title="Kart Görseli" :imageUrl="null" :required="true">
                  </DragDropImage>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                      name="Görsel Başlığı (title)">
                      <b-form-textarea id="imageTitle" v-model="imageTitle" placeholder="Görsel Başlığı (title)"
                        rows="3" class="char-textarea" :state="errors.length > 0 ? false : null" :class="
                          imageTitle.length >= chars.imageTitle
                            ? 'text-danger'
                            : ''
                        " />
                      <small class="textarea-counter-value float-right" :class="
                        imageTitle.length >= chars.imageTitle
                          ? 'bg-danger'
                          : ''
                      ">
                        <span class="char-count">{{ imageTitle.length }}</span>
                        /
                        {{ chars.imageTitle }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label="Görsel Açıklaması (alt text)" label-for="imageAltText">
                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                      name="Görsel Açıklaması (alt text)">
                      <b-form-textarea id="imageAltText" v-model="imageAltText"
                        placeholder="Görsel Açıklaması (alt text)" rows="3" class="char-textarea"
                        :state="errors.length > 0 ? false : null" :class="
                          imageAltText.length >= chars.imageAltText
                            ? 'text-danger'
                            : ''
                        " />
                      <small class="textarea-counter-value float-right" :class="
                        imageAltText.length >= chars.imageAltText
                          ? 'bg-danger'
                          : ''
                      ">
                        <span class="char-count">{{
                          imageAltText.length
                        }}</span>
                        /
                        {{ chars.imageAltText }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="8">
                  <DragDropImage ref="refBannerImage" title="Banner Görseli" :imageUrl="null" :required="true">
                  </DragDropImage>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Bağlantı Linki" label-for="slug">
                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Bağlantı Linki">
                      <b-form-input id="slug" v-model="slug" placeholder="Bağlantı Linki"
                        :state="errors.length > 0 ? false : null"
                        :class="slug.length >= chars.slug ? 'text-danger' : ''" />
                      <small class="textarea-counter-value float-right"
                        :class="slug.length >= chars.slug ? 'bg-danger' : ''">
                        <span class="char-count">{{ slug.length }}</span>
                        /
                        {{ chars.slug }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Canonical Link" label-for="canonicalUrl">
                    <validation-provider #default="{ errors }" :rules="{ required: false }" name="Canonical Link">
                      <b-form-input id="slug" v-model="canonicalUrl" placeholder="Canonical Link"
                        :state="errors.length > 0 ? false : null"
                        :class="canonicalUrl.length >= chars.canonicalUrl ? 'text-danger' : ''" />
                      <small class="textarea-counter-value float-right"
                        :class="canonicalUrl.length >= chars.canonicalUrl ? 'bg-danger' : ''">
                        <span class="char-count">{{ canonicalUrl.length }}</span>
                        /
                        {{ chars.canonicalUrl }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Meta Başlığı" label-for="metaTitle">
                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Meta Başlığı">
                      <b-form-input id="metaTitle" v-model="metaTitle" placeholder="Meta Başlığı"
                        :state="errors.length > 0 ? false : null"
                        :class="metaTitle.length >= chars.metaTitle ? 'text-danger' : ''" />
                      <small class="textarea-counter-value float-right"
                        :class="metaTitle.length >= chars.metaTitle ? 'bg-danger' : ''">
                        <span class="char-count">{{ metaTitle.length }}</span>
                        /
                        {{ chars.metaTitle }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
              <b-col md="12">
                  <b-form-group label="Meta Açıklaması" label-for="metaDescription">
                    <validation-provider #default="{ errors }" :rules="{ required: true, min: 30 }"
                      name="Meta Açıklaması">
                      <b-form-textarea id="metaDescription" v-model="metaDescription" placeholder="Meta Açıklaması"
                        rows="3" class="char-textarea" :state="errors.length > 0 ? false : null" :class="
                          metaDescription.length >= chars.metaDescription
                            ? 'text-danger'
                            : ''
                        " />
                      <small class="textarea-counter-value float-right" :class="
                        metaDescription.length >= chars.metaDescription
                          ? 'bg-danger'
                          : ''
                      ">
                        <span class="char-count">{{
                          metaDescription.length
                        }}</span>
                        /
                        {{ chars.metaDescription }}
                      </small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" class="mt-5">
                  <div>
                    <b-button class="float-right mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-success" @click="postConfirmText(false)">
                      <b-spinner v-if="spinner === true && isDraft === false" small />
                      {{
  spinner === true && isDraft === false
  ? "Yayınlanıyor"
  : "Yayınla"
                      }}
                    </b-button>
                  </div>
                  <div>
                    <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-warning" @click="postConfirmText(true)">
                      <b-spinner v-if="spinner == true && isDraft == true" small />
                      {{
  spinner == true && isDraft == true
  ? "Taslağa Kaydediliyor"
  : "Taslağa Kaydet"
                      }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import DragDropImage from "../components/DragDropImage"
import EditorById from "../components/EditorById";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    EditorById,
    BImg,
    BRow,
    BCol,
    BLink,
    BCard,
    BForm,
    BMedia,
    BAlert,
    BButton,
    BSpinner,
    BFormFile,
    BCardText,
    BFormGroup,
    BFormInput,
    BMediaBody,
    BInputGroup,
    BMediaAside,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      text: "",
      name: "",
      slug: "",
      canonicalUrl: " ",
      isDraft: false,
      linkTitle: "",
      imageTitle: "",
      imageAltText: "",
      metaTitle: "",
      metaDescription: "",
      spinner: false,
      chars: {
        name: 55,
        slug: 255,
        canonicalUrl: 1000,
        linkTitle: 55,
        imageTitle: 60,
        imageAltText: 140,
        metaTitle: 65,
        metaDescription: 160,
      },
      snowOption: {
        theme: "snow",
      },
      languages: [],
      selectedLanguage: null,

      categories: [],
      selectedCategory: null,

      categoryTypes: [],
      selectedCategoryType: null,
      featuredImage: require("@/assets/images/placeholder/1920x1080.jpg"),
      isLoaded: false
    };
  },
  watch: {
    name(newName, oldName) {
      this.slug = newName;
      this.linkTitle = newName;
      this.metaTitle = newName;
      this.imageTitle = newName;
      this.imageAltText = newName;
    },
    slug(newSlug, oldSlug) {
      this.slug = this.slugify(newSlug);
    },
  },
  methods: {
    slugify(text, ampersand = "and") {
      const a = "àáäâèéëêıìíïîòóöôùúüûñçßÿỳýœæŕśşńṕẃǵğǹḿǘẍźḧ";
      const b = "aaaaeeeeiiiiioooouuuuncsyyyoarssnpwggnmuxzh";
      const p = new RegExp(a.split("").join("|"), "g");

      return text
        .toString()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(p, (c) => b.charAt(a.indexOf(c)))
        .replace(/&/g, `-${ampersand}-`)
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni kategoriyi kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("slug", this.slug);
          formData.append("canonicalUrl", this.canonicalUrl.trim() == "" ? null : this.canonicalUrl);
          formData.append("text", JSON.stringify(this.$refs.refEditor.eData));
          formData.append("information", JSON.stringify(this.$refs.refEditorInformation.eData));
          formData.append("name", this.name);
          formData.append("image", this.$refs.refCardImage.image);
          formData.append("banner", this.$refs.refBannerImage.image);
          formData.append("categoryTypeId", this.selectedCategoryType.id);
          formData.append("isDraft", this.isDraft);
          formData.append("linkTitle", this.linkTitle);
          formData.append("imageTitle", this.imageTitle);
          formData.append("imageAltText", this.imageAltText);
          formData.append("metaTitle", this.metaTitle);
          formData.append("metaDescription", this.metaDescription);
          if (this.selectedCategory.id != null) {
            formData.append("parentId", this.selectedCategory.id);
          }
          endpoints
            .postCategories(formData, this.$i18n.locale, () => { })
            .then((data) => {
              this.$swal({
                icon: "success",
                title: "Kayıt başarılı!",
                text: "Yeni kategori eklendi.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then((result) => {
                if (result.value) {
                  this.$router.push({ path: "/categories" });
                }
              });
              this.spinner = false;
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.languages = [...data.response];
          this.selectedLanguage = this.languages.find(
            (element) => element.locale == this.$i18n.locale
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategories() {
      endpoints
        .getCategories(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.categories = [...[{ name: "Yok", id: null }], ...data.response];
          this.selectedCategory = this.categories[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryTypes() {
      endpoints
        .getCategoryTypes(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.categoryTypes = [...data.response];
          this.selectedCategoryType = this.categoryTypes[0];
          this.isLoaded = true
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() { },
  mounted() {
    this.getLanguages();
    this.getCategories();
    this.getCategoryTypes();
  },
  setup() {

  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
